/*
 * @Description: 正则常量
 * @Author: 山淑兰
 * @Date: 2019-12-27 20:03:53
 * @LastEditTime : 2020-01-16 15:52:33
 * @LastEditors  : 山淑兰
 */
export const PhoneRegExp = /^1[1-9]\d{9}$/;
export const EmailRegExp = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/;
export const NumberRegExp = /^\d+$|^\d+[.]?\d+$/;
